import React, { useCallback, useEffect, useState } from 'react';
import { Input, Select, Radio, Space, Spin, Form } from 'antd';
import { JSXMap, CollectionServer, useMetaContext, useCollectionRef, Field, QueryDetail, QueryOrder, ObjectToContextFilters } from 'fennec-ui'
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import User from '../../../common/User';
import ObjectOwnerDescription from '../../../fedance-ui/ObjectOwnerDescription';
import ObjectVtpDescription from '../../../fedance-ui/ObjectVtpDescription';
import YImage from '../../../common/YImage';
import ObjectContextDescription from '../../../fedance-ui/ObjectContextDescription';
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

var _ = require('lodash');

function VsetipipolzovateleiCollectionField(props) {
    const { auth, value, onChange } = props;
    const meta = useMetaContext();
    const filtersFromMeta = React.useCallback((name) => {
        let prop = [];
        let p = _.get(meta[name], "properties");
        if (p) {
            prop = p?.filter(e => !_.get(e, "relation") || _.get(e, "relation.type") !== "one-many")?.map(e => ({ ...e, /*mode: "dialog",*/ sort: true, filter: true, func: (e.filterType == "range") ? ["min", "max"] : undefined }))
        }
        return prop.map(element => ({
            name: element.name,
            type: element.type,
            label: element.label,
            relation: element.relation,
            filterType: element.filterType,
            sort: true,
            filter: true
        }));
    }, [meta]);

    // console.log(filtersFromMeta("VseTipiPolzovatelei"));
    // console.log(filtersFromMeta("OrganizatoriFederatsii"));
    // console.log(filtersFromMeta("RegionalnieOtdeleniya"));

    const x = useCallback(() => ([
        ...ObjectToContextFilters({ dokumentPodtverzhdeniyaID: 1, dokumentZapisiID: 1 }, "nnu"),
        ...ObjectToContextFilters({ dokumentOtmeniZapisiID: 1 }, "nu")
    ]), [])
    return (
        <CollectionServer
            onApplyFilter={(x) => {
                // console.log(x);
                if (onChange) {
                    onChange(x)
                }
            }}
            contextFilters={x}
            onChangeRequestParameters={(x) => {
                if (onChange) {
                    onChange(x)
                }
            }}
            auth={auth}
            name={"VseTipiPolzovatelei"}
            source={"/api/vsetipipolzovatelei/all/list"}
            // filters={() => filtersFromMeta("VseTipiPolzovatelei")}
            filters={() => [
                {
                    "name": "TipPolzovatelya",
                    "type": "object",
                    "label": "Тип пользователя",
                    "relation": {
                        "type": "many-one",
                        displayString: (item) => {
                            return item?.opisanie
                        },
                        display: (item) => {
                            return (
                                item?.opisanie
                            )
                        },
                        "reference": {
                            "object": "TipiPolzovatelei",
                            "property": "ID"
                        },
                    },
                    queryFilter: [
                        QueryOrder("opisanie", "ASC")
                    ],
                    "sort": true,
                    "filter": true
                },
                {
                    label: <div style={{ lineHeight: "16px", marginBottom: "3px" }}>
                        <div style={{ fontSize: "12px", fontWeight: "lighter", color: "#6a6a6a" }}>Пользователь</div>
                        <div>email</div>
                    </div>,
                    name: "User.email",
                    sort: true,
                    filter: true,
                },
                {
                    mode: "dialog",
                    "name": "User",
                    "type": "object",
                    "label": "Пользователь",
                    "relation": {
                        uiFilter: () => [
                            {
                                name: "lastname",
                                sort: true,
                                filter: true,
                            },
                            {
                                name: "firstname",
                                sort: true,
                                filter: true,
                            },
                            {
                                name: "patronymic",
                                sort: true,
                                filter: true,
                            },

                            {
                                name: "email",
                                sort: true,
                                filter: true,
                            },
                            {
                                label: "Телефон",
                                name: "phone",
                                sort: true,
                                filter: true,
                            },
                            {
                                name: "gender",
                                sort: true,
                                filter: true,
                                display: (o) => o.name,
                            },
                            {
                                label: "Дата создания",
                                name: "createdAt",
                                type: "date",
                                sort: true,
                                filter: true,
                            },
                        ],
                        displayString: (item) => {
                            return item?.lastname + " " + item?.firstname
                        },
                        display: (item) => {
                            return (
                                <User item={item} />
                            )
                        },
                        "type": "many-one",
                        "reference": {
                            "object": "User",
                            "property": "ID"
                        },
                    },
                    "sort": true,
                    "filter": true
                },
                {
                    "name": "Shkola",
                    "type": "object",
                    "label": "Школа",
                    "relation": {
                        "type": "many-one",
                        "reference": {
                            "object": "ShkoliFederatsii",
                            "property": "ID"
                        },
                    },
                    queryFilter: [
                        QueryDetail("collection")
                    ],
                    "sort": true,
                    "filter": true
                },
                {
                    "name": "Shkola.RegionalnoeOtdelenie",
                    "type": "object",
                    "label": <div style={{ lineHeight: "16px", marginBottom: "3px" }}>
                        <div style={{ fontSize: "12px", fontWeight: "lighter", color: "#6a6a6a" }}>Школа</div>
                        <div>Региональное отделение</div>
                    </div>,
                    "relation": {
                        "type": "many-one",
                        "reference": {
                            "object": "RegionalnieOtdeleniya",
                            "property": "ID"
                        },
                    },
                    queryFilter: [
                        QueryDetail("collection")
                    ],
                    "sort": true,
                    "filter": true
                },
                {
                    mode: "dialog",
                    "name": "Organizator",
                    "type": "object",
                    "label": "Организатор",
                    "relation": {
                        uiFilter: () => [
                            {
                                name: "nazvanie",
                                sort: true,
                                filter: true,
                            },
                            {
                                name: "user.lastname",
                                sort: true,
                                filter: true,
                            },
                            {
                                name: "user.firstname",
                                sort: true,
                                filter: true,
                            },
                            {
                                name: "user.patronymic",
                                sort: true,
                                filter: true,
                            },

                            {
                                name: "user.email",
                                sort: true,
                                filter: true,
                            },
                            {
                                label: "Телефон",
                                name: "user.phone",
                                sort: true,
                                filter: true,
                            },
                            {
                                name: "user.gender",
                                sort: true,
                                filter: true,
                                display: (o) => o.name,
                            },
                            {
                                label: "Дата создания",
                                name: "user.createdAt",
                                type: "date",
                                sort: true,
                                filter: true,
                            },
                        ],
                        "type": "many-one",
                        "reference": {
                            "object": "OrganizatoriFederatsii",
                            "property": "ID"
                        },
                    },
                    queryFilter: [
                        QueryDetail("collection")
                    ],
                    "sort": true,
                    "filter": true
                },
                {
                    "name": "Organizator.RegionalnoeOtdelenie",
                    "type": "object",
                    "label": <div style={{ lineHeight: "16px", marginBottom: "3px" }}>
                        <div style={{ fontSize: "12px", fontWeight: "lighter", color: "#6a6a6a" }}>Организатор</div>
                        <div>Региональное отделение</div>
                    </div>,//"Организатор - Региональное отделение",
                    "relation": {
                        "type": "many-one",
                        "reference": {
                            "object": "RegionalnieOtdeleniya",
                            "property": "ID"
                        },
                    },
                    queryFilter: [
                        QueryDetail("collection")
                    ],
                    "sort": true,
                    "filter": true
                },
                // {
                //     "name": "Tantsor",
                //     "type": "object",
                //     "label": "Танцор",
                //     "relation": {
                //         "type": "many-one",
                //         "reference": {
                //             "object": "TantsoriFederatsii",
                //             "property": "ID"
                //         },
                //     },
                //     queryFilter: [
                //         QueryDetail("collection")
                //     ],
                //     "sort": true,
                //     "filter": true
                // },
                {
                    "name": "Tantsor.RegionalnoeOtdelenie",
                    "type": "object",
                    "label": <div style={{ lineHeight: "16px", marginBottom: "3px" }}>
                        <div style={{ fontSize: "12px", fontWeight: "lighter", color: "#6a6a6a" }}>Танцор</div>
                        <div>Региональное отделение</div>
                    </div>,
                    "relation": {
                        "type": "many-one",
                        "reference": {
                            "object": "RegionalnieOtdeleniya",
                            "property": "ID"
                        },
                    },
                    queryFilter: [
                        QueryDetail("collection")
                    ],
                    "sort": true,
                    "filter": true
                },
                // {
                //     "name": "Sudya",
                //     "type": "object",
                //     "label": "Судья",
                //     "relation": {
                //         "type": "many-one",
                //         "reference": {
                //             "object": "SudiFederatsii",
                //             "property": "ID"
                //         },
                //     },
                //     queryFilter: [
                //         QueryDetail("collection")
                //     ],
                //     "sort": true,
                //     "filter": true
                // },
                {
                    "name": "Sudya.RegionalnoeOtdelenie",
                    "type": "object",
                    "label": <div style={{ lineHeight: "16px", marginBottom: "3px" }}>
                        <div style={{ fontSize: "12px", fontWeight: "lighter", color: "#6a6a6a" }}>Судья</div>
                        <div>Региональное отделение</div>
                    </div>,
                    "relation": {
                        "type": "many-one",
                        "reference": {
                            "object": "RegionalnieOtdeleniya",
                            "property": "ID"
                        },
                    },
                    queryFilter: [
                        QueryDetail("collection")
                    ],
                    "sort": true,
                    "filter": true
                },
                // {
                //     "name": "Prepodavatel",
                //     "type": "object",
                //     "label": "Преподаватель",
                //     "relation": {
                //         "type": "many-one",
                //         "reference": {
                //             "object": "PrepodavateliFederatsii",
                //             "property": "ID"
                //         },
                //     },
                //     queryFilter: [
                //         QueryDetail("collection")
                //     ],
                //     "sort": true,
                //     "filter": true
                // },
                {
                    "name": "Prepodavatel.RegionalnoeOtdelenie",
                    "type": "object",
                    "label": <div style={{ lineHeight: "16px", marginBottom: "3px" }}>
                        <div style={{ fontSize: "12px", fontWeight: "lighter", color: "#6a6a6a" }}>Преподаватель</div>
                        <div>Региональное отделение</div>
                    </div>,
                    "relation": {
                        "type": "many-one",
                        "reference": {
                            "object": "RegionalnieOtdeleniya",
                            "property": "ID"
                        },
                    },
                    queryFilter: [
                        QueryDetail("collection")
                    ],
                    "sort": true,
                    "filter": true
                },
                // {
                //     // mode: "dialog",
                //     "name": "Kollektiv",
                //     "type": "object",
                //     "label": "Коллектив",
                //     "relation": {
                //         "type": "many-one",
                //         "reference": {
                //             "object": "KollektiviFederatsii",
                //             "property": "ID"
                //         },
                //     },
                //     queryFilter: [
                //         QueryDetail("collection")
                //     ],
                //     "sort": true,
                //     "filter": true
                // },
                {
                    "name": "Kollektiv.RegionalnoeOtdelenie",
                    "type": "object",
                    "label": <div style={{ lineHeight: "16px", marginBottom: "3px" }}>
                        <div style={{ fontSize: "12px", fontWeight: "lighter", color: "#6a6a6a" }}>Коллектив</div>
                        <div>Региональное отделение</div>
                    </div>,
                    "relation": {
                        "type": "many-one",
                        "reference": {
                            "object": "RegionalnieOtdeleniya",
                            "property": "ID"
                        },
                    },
                    queryFilter: [
                        QueryDetail("collection")
                    ],
                    "sort": true,
                    "filter": true
                },
                // {
                //     "name": "Para",
                //     "type": "object",
                //     "label": "Пара",
                //     "relation": {
                //         "type": "many-one",
                //         "reference": {
                //             "object": "PariFederatsii",
                //             "property": "ID"
                //         },
                //     },
                //     queryFilter: [
                //         QueryDetail("collection")
                //     ],
                //     "sort": true,
                //     "filter": true
                // },
                {
                    "name": "Para.RegionalnoeOtdelenie",
                    "type": "object",
                    "label": <div style={{ lineHeight: "16px", marginBottom: "3px" }}>
                        <div style={{ fontSize: "12px", fontWeight: "lighter", color: "#6a6a6a" }}>Пара</div>
                        <div>Региональное отделение</div>
                    </div>,
                    "relation": {
                        "type": "many-one",
                        "reference": {
                            "object": "RegionalnieOtdeleniya",
                            "property": "ID"
                        },
                    },
                    queryFilter: [
                        QueryDetail("collection")
                    ],
                    "sort": true,
                    "filter": true
                },
                // {
                //     "name": "ChlenFederatsii",
                //     "type": "object",
                //     "label": "Член федерации",
                //     "relation": {
                //         "type": "many-one",
                //         "reference": {
                //             "object": "ChleniFederatsii",
                //             "property": "ID"
                //         },
                //     },
                //     queryFilter: [
                //         QueryDetail("collection")
                //     ],
                //     "sort": true,
                //     "filter": true
                // },
                // {
                //     "name": "ChlenFederatsii.RegionalnoeOtdelenie",
                //     "type": "object",
                //     "label": <div style={{lineHeight: "16px", marginBottom:"3px"}}>
                //         <div style={{ fontSize: "12px", fontWeight: "lighter", color:"#6a6a6a"}}>Член федерации</div>
                //         <div>Региональное отделение</div>
                //     </div>,
                //     "relation": {
                //         "type": "many-one",
                //         "reference": {
                //             "object": "RegionalnieOtdeleniya",
                //             "property": "ID"
                //         },
                //     },
                //     queryFilter: [
                //         QueryDetail("collection")
                //     ],
                //     "sort": true,
                //     "filter": true
                // },
                // {
                //     "name": "RegionalnoeOtdelenie",
                //     "type": "object",
                //     "label": "Региональное отделение",
                //     "relation": {
                //         "type": "many-one",
                //         "reference": {
                //             "object": "RegionalnieOtdeleniya",
                //             "property": "ID"
                //         },
                //     },
                //     "sort": true,
                //     "filter": true
                // },
            ]}
            customRender={(items, {
                objectName,
                contextObject,
                collection,
                setCollection,
                setCollectionItem,
                removeCollectionItem,
                collectionActions,
                modelActions,
                onSelection,
                isSelected,
                lock,
                unlock,
                loading,
                update
            }) => {
                // console.log(items);
                return (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <Spin spinning={loading} style={{ paddingTop: "15px", paddingBottom: "15px" }} />
                        {JSXMap(items, (item, oidx) => {
                            return (<div key={oidx} className={`bg bg-grey-hover light`} style={{ textAlign: "left" }}>
                                <User item={item?.user} />
                                <div style={{
                                    fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)", textAlign: "left", textWrap: "nowrap",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis"
                                }}>{item?.tipPolzovatelya?.opisanie}</div>
                                <div style={{
                                    fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)", textAlign: "left", textWrap: "nowrap",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis"
                                }}><ObjectVtpDescription object={item} /></div>
                            </div>)
                        })}
                    </div>
                )
            }}
        />
    )
}
function EventusersCollectionField(props) {
    const { auth, value, onChange, meropriyatieID } = props;
    const meta = useMetaContext();
    const filtersFromMeta = React.useCallback((name, deep) => {
        let prop = [];
        let p = _.get(meta[name], "properties");
        if (p) {
            prop = p?.filter(e => !_.get(e, "relation") || _.get(e, "relation.type") !== "one-many")?.map(e => ({ ...e, sort: true, filter: true, func: (e.filterType == "range") ? ["min", "max"] : undefined }))

            // if (deep) {
            //     let inner = []
            //     for (let i = 0; i < prop.length; i++) {
            //         const element = prop[i];
            //         if (element.type === "object") {
            //             let nn = _.get(element, "relation.reference.object")
            //             if (element.name) {
            //                 let nna = filtersFromMeta(nn, false)
            //                 for (let j = 0; j < nna.length; j++) {
            //                     const nnaj = nna[j];
            //                     inner.push({
            //                         ...nnaj,
            //                         name: element.name + "." + nnaj.name,
            //                         label: element.label + "." + nnaj.label,
            //                         sort: true,
            //                         filter: true
            //                     })
            //                 }
            //             }

            //         }
            //     }
            //     console.log(inner);
            //     prop.push(inner);
            // }
        }
        return prop.map(element => ({
            name: element.name,
            type: element.type,
            label: element.label,
            relation: element.relation,
            filterType: element.filterType,
            sort: true,
            filter: true
        }));
    }, [meta]);

    // console.log(filtersFromMeta("EventUser"));

    // console.log(filtersFromMeta("User"));
    // console.log(filtersFromMeta("RegionalnieOtdeleniya"));

    return (<CollectionServer
        onApplyFilter={(x) => {
            if (onChange) {
                onChange(x)
            }
        }}
        onChangeRequestParameters={(x) => {
            if (onChange) {
                onChange(x)
            }
        }}
        auth={auth}
        source={`/api/eventuser/all/list/${meropriyatieID}`}
        // filters={() => filtersFromMeta("EventUser", true)}
        filters={() => [
            {
                "name": "EventUserType",
                "type": "object",
                "label": "Тип участника",
                "relation": {
                    "type": "many-one",
                    "reference": {
                        "object": "EventUserType",
                        "property": "ID"
                    },
                },
                queryFilter: [
                    QueryOrder("ID", "ASC")
                ],
                "sort": true,
                "filter": true
            },
            {
                label: <div style={{ lineHeight: "16px", marginBottom: "3px" }}>
                    <div style={{ fontSize: "12px", fontWeight: "lighter", color: "#6a6a6a" }}>Пользователь</div>
                    <div>email</div>
                </div>,
                name: "User.email",
                type: "string",
                sort: true,
                filter: true,
            },
            {
                mode: "dialog",
                "name": "User",
                "type": "object",
                "label": "Пользователь",
                "relation": {
                    uiFilter: () => [
                        {
                            name: "lastname",
                            sort: true,
                            filter: true,
                        },
                        {
                            name: "firstname",
                            sort: true,
                            filter: true,
                        },
                        {
                            name: "patronymic",
                            sort: true,
                            filter: true,
                        },

                        {
                            name: "email",
                            sort: true,
                            filter: true,
                        },
                        {
                            label: "Телефон",
                            name: "phone",
                            sort: true,
                            filter: true,
                        },
                        {
                            name: "gender",
                            sort: true,
                            filter: true,
                            display: (o) => o.name,
                        },
                        {
                            label: "Дата создания",
                            name: "createdAt",
                            type: "date",
                            sort: true,
                            filter: true,
                        },
                    ],
                    displayString: (item) => {
                        return item?.lastname + " " + item?.firstname
                    },
                    display: (item) => {
                        return (
                            <User item={item} />
                        )
                    },
                    "type": "many-one",
                    "reference": {
                        "object": "User",
                        "property": "ID"
                    },
                },
                "sort": true,
                "filter": true
            },
            {
                "name": "Checked",
                "type": "bool",
                "label": "Победитель розыгрыша",
                "sort": true,
                "filter": true
            },
        ]}
        customRender={(items, {
            objectName,
            contextObject,
            collection,
            setCollection,
            setCollectionItem,
            removeCollectionItem,
            collectionActions,
            modelActions,
            onSelection,
            isSelected,
            lock,
            unlock,
            loading,
            update
        }) => {
            // console.log(items);
            return (
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <Spin spinning={loading} style={{ paddingTop: "15px", paddingBottom: "15px" }} />
                    {JSXMap(items, (item, oidx) => {
                        return (<div key={oidx} className={`bg bg-grey-hover light`} style={{ textAlign: "left" }}>
                            <User item={item?.user} />
                            <div style={{
                                fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)", textAlign: "left", textWrap: "nowrap",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis"
                            }}>{item?.eventUserType?.description}</div>
                            <div style={{ color: "#6a6a6a" }}><ObjectContextDescription object={item} /></div>
                        </div>)
                    })}
                </div>
            )
        }}
    />)
}
export default function CopyPolzovateliGruppi(props) {
    const { auth, object, form } = props;

    useEffect(() => {
        form.resetFields();
    }, []);

    const [value, setValue] = useState(1);
    const onChange = (e) => {
        setValue(e.target.value);
    };

    const meropriyatieID = Form.useWatch('meropriyatieID', form);

    return (
        <>
            <div className='bg bg-transparent border-grey' style={{ textAlign: "left" }}>
                <Radio.Group onChange={onChange} value={value} defaultValue={value}>
                    <Space direction="vertical">
                        <Radio value={1}>
                            <div>
                                <div>из пользователей Федерации</div>
                                <div style={{ fontSize: "12px", fontWeight: "lighter" }}>(по типу пользователя)</div>
                            </div></Radio>
                        <Radio value={2}>
                            <div>
                                <div>из участников мероприятия</div>
                                <div style={{ fontSize: "12px", fontWeight: "lighter" }}>(по данным из в jack)</div>
                            </div></Radio>
                    </Space>
                </Radio.Group>
            </div>


            <Form
                form={form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
            >
                {value === 2 && <Form.Item label="Мероприятие" name="meropriyatieID" style={{ paddingTop: "15px" }}>
                    <Field
                        mode="model"
                        key={meropriyatieID}
                        // objectName={name}
                        // contextObject={contextObject}
                        auth={auth}
                        item={{
                            // label: "Мероприятие",
                            name: "meropriyatie",
                            type: "object",
                            mode: "dialog",
                            modal: { width: "700px" },
                            relation: {
                                uiFilter: () => [
                                    {
                                        label: "Дата начала",
                                        name: "nachaloSorevnovaniya",
                                        type: "date",
                                        filterType: "range",
                                        sort: true,
                                        filter: true,

                                        sorted: "ASC",
                                        filtered: [dayjs().subtract(5, "days"), dayjs().add(1, "years")],
                                    },
                                    {   // Тип мероприятия
                                        label: "Тип мероприятия",
                                        name: "tipMeropriyatiya",
                                        filterType: "group",
                                        display: (o) => o.opisanie,
                                        sort: true,
                                        filter: true
                                    },
                                    {   // Уровень мероприятия
                                        label: "Уровень мероприятия",
                                        name: "urovenMeropriyatiya",
                                        filterType: "group",
                                        display: (o) => o.opisanie,
                                        sort: true,
                                        filter: true
                                    },
                                    {   // Место проведения
                                        label: "Место проведения",
                                        name: "mestoProvedeniya",
                                        filterType: "group",
                                        display: (o) => o.name,
                                        sort: true,
                                        filter: true
                                    },
                                ],
                                displayString: (item) => {
                                    return dayjs(item.nachaloSorevnovaniya).format("DD.MM.YYYY") + " - " + item.nazvanieMeropriyatiya + ", " + item?.mestoProvedeniya?.name
                                },
                                display: (item) => {
                                    return (
                                        <div key={item.ID} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", padding: "2px 5px", marginBottom: "5px" }}>

                                            <div style={{ width: "32px", height: "32px", overflow: "hidden", borderRadius: "4px" }}>
                                                <YImage item={item} width={32} hidePreview={true} />
                                            </div>

                                            <div style={{ flex: "auto", paddingLeft: "7px" }}>
                                                <div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "14px" }}>
                                                    <a href={`/fed/event/${item.ID}`}>
                                                        <span style={{ fontWeight: "600" }}>{item.nazvanieMeropriyatiya}</span>
                                                    </a>
                                                </div>
                                                <div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "12px" }}>
                                                    <span style={{
                                                        marginRight: "5px",
                                                        borderRadius: "5px",

                                                        // backgroundColor: "#f6214b",
                                                        // color: "white",

                                                        backgroundColor: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "#eaeaea" : "#f6214b",
                                                        color: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "black" : "white",
                                                        fontWeight: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "400" : "600",

                                                        fontSize: "12px",


                                                        boxShadow: "rgba(34, 60, 80, 0.3) 0px 3px 1px -2px",
                                                        padding: "2px 4px"
                                                    }}>{dayjs(item.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}</span>
                                                    <span>{item?.mestoProvedeniya?.name}</span>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                },
                                reference: { object: "Meropriyatiya", property: "ID", source: "/api/meropriyatiya/list/com" },
                                type: "many-one",
                            },
                            queryFilter: [
                                QueryDetail("combobox"),
                                QueryOrder("nachaloSorevnovaniya", "DESC")
                            ]
                        }}
                    />
                </Form.Item>}
                {(value === 1 || (value === 2 && meropriyatieID)) && <div style={{ fontSize: "12px", fontWeight: "lighter", paddingTop: "15px" }}>Будут отправлены все пользователи из списка в соответствии с установленным фильтром:</div>}
                {value === 1 && <Form.Item label="" name="vsetipipolzovatelei">
                    <VsetipipolzovateleiCollectionField auth={auth} />
                </Form.Item>}
                {(value === 2 && meropriyatieID) && <Form.Item label="" name="eventusers">
                    <EventusersCollectionField auth={auth} meropriyatieID={meropriyatieID} />
                </Form.Item>}
            </Form>
        </>
    );
}
